"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.schoolInputVisibility = void 0;
/* ========================================================================
    Module: School input visibility
 ========================================================================== */
const schoolInputVisibility = () => {
    const schoolInputs = document.querySelector(".js-school-inputs");
    if (!schoolInputs) {
        return;
    }
    const inputSelectors = schoolInputs.querySelectorAll(".js-school-input-selector");
    const inputDetails = schoolInputs.querySelectorAll(".js-school-input-detail");
    inputDetails.forEach((element) => {
        formControlsDisabled(element, true);
    });
    inputSelectors.forEach((element) => {
        if (element.checked) {
            formControlsDisabled(inputDetailForSelector(element), false);
        }
        element.addEventListener("change", (e) => {
            if (!(e.currentTarget instanceof HTMLInputElement)) {
                return;
            }
            inputDetails.forEach((element) => {
                formControlsDisabled(element, true);
            });
            if (e.currentTarget.checked) {
                formControlsDisabled(inputDetailForSelector(e.currentTarget), false);
            }
        });
    });
};
exports.schoolInputVisibility = schoolInputVisibility;
/**
 * 指定した要素の入力フォームの親要素を返す
 *
 * @param {HTMLElement} element
 * @returns {HTMLElement | null}
 */
const inputDetailForSelector = (element) => {
    const parentNode = element.closest(".js-school-input-item");
    const inputDetail = parentNode?.querySelector(".js-school-input-detail");
    return inputDetail ?? null;
};
/**
 * 指定した要素が内包するフォームを有効／無効化する
 *
 * @param {HTMLElement | null} element
 * @param {boolean} isDisabled
 * @returns {void}
 */
const formControlsDisabled = (element, isDisabled) => {
    if (!element) {
        return;
    }
    const formControlsElements = element.querySelectorAll("input, select, textarea, button");
    formControlsElements?.forEach((element) => {
        element.disabled = isDisabled;
    });
};
